const MAX_TOTAL_QTY = 10000;

// Utility: Parse product:maxQty string into a mapping
function parseBlockedProducts(str) {
  const map = {};
  str.split(",").forEach((pair) => {
    const [name, qty] = pair.split(":");
    if (name && qty) map[name.trim()] = parseInt(qty.trim(), 10);
  });
  return map;
}

// Utility: Check if a blocked product exceeds its max quantity
function hasBlockedProductExceeded(item, blockedProductsMap) {
  const maxQty = blockedProductsMap[item.product_title];
  return maxQty !== undefined && item.quantity > maxQty;
}

// Utility: Fetch current cart items
async function fetchCartItems() {
  try {
    const res = await fetch("/cart.js");
    const data = await res.json();
    return data.items || [];
  } catch (err) {
    console.error("Cart fetch failed:", err);
    return [];
  }
}

// Utility: Toggle popup visibility
function togglePopup(show = true, isProductBlocked = false) {
  const popupGeneral = document.querySelector('[data-id="popup_Ym6m4C"]');
  const popupProduct = document.querySelector('[data-id="popup_HwqkzQ"]');
  const wrapper = document.getElementById(
    "shopify-section-sections--18460145123414__popup"
  );

  if (!wrapper) return;

  if (show) {
    wrapper.style.display = "block";
    if (isProductBlocked) {
      popupGeneral.classList.remove("visible", "animation--popup-revealed");
      popupProduct.classList.add("visible", "animation--popup-revealed");
    } else {
      popupProduct.classList.remove("visible", "animation--popup-revealed");
      popupGeneral.classList.add("visible", "animation--popup-revealed");
    }
  } else {
    wrapper.style.display = "none";
  }
}

// Utility: Get total quantity from input fields on the page
const getTotalQty = () => {
  let total = 0;
  document.querySelectorAll(".quantity-input__input").forEach((input) => {
    total += parseInt(input.value || 0, 10);
  });
  return total;
};

// Main handler: check limits and submit form
const handleCheckAndSubmit = async (e, form) => {
  const settings = window._overlimitSettings || {};
  const blockedProductsMap = parseBlockedProducts(settings?.products || "");

  const totalInputQty = getTotalQty();

  e.preventDefault();
  e.stopPropagation();

  let buttonForm = form;
  if (!buttonForm) {
    const btn = e.target;
    buttonForm = btn.closest("form");
    if (!buttonForm) return;
  }

  const cartItems = await fetchCartItems();
  const totalQty = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  const blockedExceeded = cartItems.some((item) =>
    hasBlockedProductExceeded(item, blockedProductsMap)
  );

  console.log("Validation Check — Total Qty:", totalQty, "Blocked Exceeded:", blockedExceeded);

  if (totalQty > MAX_TOTAL_QTY || blockedExceeded || totalInputQty > MAX_TOTAL_QTY) {
    togglePopup(true, blockedExceeded);
  } else {
    buttonForm?.setAttribute("action", "/checkout");
    buttonForm?.submit();
  }
};

// Attach handlers to all checkout buttons
function attachCartValidationHandlers() {
  const checkoutButtons = document.querySelectorAll(
    ".quick-cart__submit, .cart__submit, .purchase-confirmation-popup__submit"
  );

  checkoutButtons.forEach((btn) => {
    const form = btn.closest("form");
    if (!form) return;
    form.addEventListener("submit", (e) => handleCheckAndSubmit(e, form));
  });
}

// Initialize
window.addEventListener("DOMContentLoaded", () => {
  attachCartValidationHandlers();
});
// Run this on your cart / main pages
window.addEventListener("DOMContentLoaded", () => {
  // Replace current history state
  history.replaceState(null, document.title, window.location.href);
  // Push a dummy state so back button can be trapped
  history.pushState(null, document.title, window.location.href);

  window.addEventListener("popstate", function (event) {
    // User clicked back
    // Check if they are trying to go to checkout page
    const checkoutUrlPattern = /checkout/i; // match Shopify checkout
    const previousUrl = document.referrer || '';
    if (previousUrl.match(checkoutUrlPattern)) {
      // Redirect back to cart or home
      alert("You cannot go back to checkout.");
      window.location.href = "/cart"; // or home page
    }
  });
});
